export const COVERAGE_DETAILS_REQUEST = "COVERAGE_DETAILS_REQUEST";
export const COVERAGE_DETAILS_RESULT = "COVERAGE_DETAILS_RESULT";
export const COVERAGE_DETAILS_OPEN_MODAL = "COVERAGE_DETAILS_OPEN_MODAL";
export const COVERAGE_DETAILS_CLOSE_MODAL = "COVERAGE_DETAILS_CLOSE_MODAL";
export const COVERAGE_DETAILS_GET_DEVICE_REQUEST = "COVERAGE_DETAILS_GET_DEVICE_REQUEST";
export const COVERAGE_DETAILS_GET_DEVICE_RESULT = "COVERAGE_DETAILS_GET_DEVICE_RESULT";

export const COVERAGE_DETAILS_SET_DEVICE = "COVERAGE_DETAILS_SET_DEVICE";

